import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { cardGroupStyle } from './CardGroup.css';

type Props = ComponentPropsWithRef<'div'>;

export const CardGroup = ({ ...delegated }: Props) => {
  return <div {...delegated} className={clsx(cardGroupStyle, delegated.className)} />;
};
